const reopenAssignmentReducer = (state, action) => {
  if (action.status !== 'success') return state;

  const {
    payload: { assignment },
  } = action;

  const assignments = state.assignments.map((item) =>
    item.externalId === assignment.externalId
      ? { ...item, status: 'live' }
      : item
  );

  return {
    ...state,
    assignments,
  };
};

export default reopenAssignmentReducer;
